import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted-foreground mt-2 text-xs"
}
const _hoisted_3 = {
  key: 1,
  class: "text-muted-foreground mt-2 text-xs"
}
const _hoisted_4 = { class: "font-bold" }

import { Badge } from '@/components/ui/badge';
    import { CardTitle } from '@/components/ui/card';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import PageCard from '@/components/PageCard.vue';
    import type { Payroll, HolidayPayObligation } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayrollSummary',
  props: {
    payroll: {},
    isApproved: { type: Boolean },
    showBadge: { type: Boolean, default: true }
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const summaries = computed(() => {
        return [
            {
                label: t('payrolls.summary.month'),
                value: t(`payrolls.edit.months.${props.payroll.month}`),
            },
            {
                label: t('payrolls.summary.year'),
                value: props.payroll.year,
            },
            {
                label: t('payrolls.summary.num_of_employees'),
                value: `${props.payroll.num_of_employees} ${t('payrolls.summary.employees')}`,
            },
            {
                label: t('payrolls.summary.updated_at'),
                value: props.payroll.updated_at_formatted,
            },
        ];
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageCard, { class: "min-w-sm flex-none self-start lg:flex-0" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardTitle), { class: "mb-2 flex items-center justify-between gap-2" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('payrolls.table.headers.status')) + " ", 1),
          (_ctx.showBadge && _ctx.isApproved)
            ? (_openBlock(), _createBlock(_unref(Badge), {
                key: 0,
                variant: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.approved_text')), 1)
                ]),
                _: 1
              }))
            : (_ctx.showBadge)
              ? (_openBlock(), _createBlock(_unref(Badge), {
                  key: 1,
                  variant: "error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.not_approved_text')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaries.value, (summary) => {
        return (_openBlock(), _createElementBlock("div", {
          key: summary.label,
          class: "flex items-center justify-between gap-2 border-b py-2 text-xs"
        }, [
          _createElementVNode("span", _hoisted_1, _toDisplayString(summary.label), 1),
          _createElementVNode("span", null, _toDisplayString(summary.value), 1)
        ]))
      }), 128)),
      (_ctx.isApproved)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)('payrolls.edit.awaiting-text-table')), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.help-text-table')) + " ", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('payrolls.edit.help-text-bold')), 1)
          ]))
    ]),
    _: 1
  }))
}
}

})